import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/crm-deal-store';

const CrmDealContextWrapper = ({ children, signedInUser }) => {
    const [store, dispatch] = useReducer(reducer, initialState);
    const myDeals = [{ id: signedInUser.crmUserId, name: signedInUser.name }];
    localStorage.setItem(`signed-in-user`, JSON.stringify(myDeals ?? null));
    
    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default CrmDealContextWrapper;
